import { useFormat } from 'vivat';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';

const { farthestDeliveryDistance } = useDeliveryAreaCode();

// Save as Flag bits
// 4 bits flag -> 8, 4, 2, 1
// Pickup    as index 0, value = 1
// 6 Wheels  as index 1, value = 2
// 10 Wheels as index 2, value = 4
// Trailer   as index 3, value = 8

function transformToInteger(arr: any) {
  let temp = 0;
  temp += (arr[0] ? 1 : 0);
  for (let i = 3; i >= 1; i -= 1) {
    temp += ((arr[i] ? 2 : 0) ** i);
  }
  return temp;
}

function integerToArray(int: number) {
  const arr = [false, false, false, false];
  if (int === 0) return arr;
  let reducedInt = int;
  if (reducedInt % 2 !== 0) {
    arr[0] = true;
    reducedInt -= 1;
  }
  for (let i = 3; i >= 1; i -= 1) {
    if (reducedInt % (2 ** i) !== reducedInt) {
      arr[0 + i] = true;
      reducedInt -= (2 ** i);
    }
  }
  return arr;
}

const YESTERDAY = `_${(new Date(useFormat.date().dayjs.subtract(1, 'day').format('YYYY-MM-DD'))).getDate()}`;
const LAST2DAY = `_${(new Date(useFormat.date().dayjs.subtract(2, 'day').format('YYYY-MM-DD'))).getDate()}`;
const LAST3DAY = `_${(new Date(useFormat.date().dayjs.subtract(3, 'day').format('YYYY-MM-DD'))).getDate()}`;
const LAST4DAY = `_${(new Date(useFormat.date().dayjs.subtract(4, 'day').format('YYYY-MM-DD'))).getDate()}`;
const LAST5DAY = `_${(new Date(useFormat.date().dayjs.subtract(5, 'day').format('YYYY-MM-DD'))).getDate()}`;
const LAST6DAY = `_${(new Date(useFormat.date().dayjs.subtract(6, 'day').format('YYYY-MM-DD'))).getDate()}`;
const LAST7DAY = `_${(new Date(useFormat.date().dayjs.subtract(7, 'day').format('YYYY-MM-DD'))).getDate()}`;

function mapLastSevenDaysDeliveryNotes(deliveryNotes: { id: ''; distanceType: ''; deliveryDate: '' }[]) {
  const sevenDays: { [x: string]: string[] } = {
    [LAST7DAY]: [],
    [LAST6DAY]: [],
    [LAST5DAY]: [],
    [LAST4DAY]: [],
    [LAST3DAY]: [],
    [LAST2DAY]: [],
    [YESTERDAY]: [],
  };
  deliveryNotes.forEach((deliveryNote: { id: ''; distanceType: ''; deliveryDate: '' }) => {
    const _date = `_${new Date(deliveryNote.deliveryDate).getDate()}`;
    if (_date === YESTERDAY
      || _date === LAST2DAY
      || _date === LAST3DAY
      || _date === LAST4DAY
      || _date === LAST5DAY
      || _date === LAST6DAY
      || _date === LAST7DAY
    ) sevenDays[`_${new Date(deliveryNote.deliveryDate).getDate()}`].push(deliveryNote.distanceType);
  });
  return Object.keys(sevenDays).map((k: string) => farthestDeliveryDistance(sevenDays[k]));
}

export default function useDriverProfile() {
  return {
    transformToInteger,
    integerToArray,

    mapLastSevenDaysDeliveryNotes,
  };
}
